import '../assets/styling/Contact.css';
import { FiArrowUpRight } from 'react-icons/fi';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_4mivu3u',
      'template_6saabye',
      form.current,
      'DVPCG15Gox58LlzNi'
    )
    .then((result) => {
        alert('Message sent!');
        form.current.reset();
    }, (error) => {
        alert('Failed to send message, please try again.');
    });
  };

  return (
    <div className="contact-card">
      <div className="contact-info">
        <h2>Contact</h2>
        <hr className="contact-hr" />
        <p>Contactați-ne acum prin telefon sau prin e-mail și vă vom răspunde cât mai curând posibil.</p>
        <div className="contact-info-block">
          <strong>Adresă Birou</strong>
          <p>Bld. Dimitrie Cantemir nr 25 bl 2 sc C etaj 5 ap 20 bucuresti sector 4 cod postal 040237</p>
        </div>
        <div className="contact-info-block">
          <strong>Adresă E-Mail</strong>
          <p>vibe9@info.ro</p>
        </div>
        <div className="contact-info-block">
          <strong>Telefon</strong>
          <p>+40 773 907 907</p>
        </div>
        <div className="contact-info-block">
          <strong>Program Birou</strong>
          <p>Luni - Vineri: 10.00 – 18.00</p>
        </div>
      </div>
      <div className="contact-form-side">
        <h3 style={{textAlign: 'center', marginBottom: '1rem'}}><br /><span style={{fontWeight: 'bold', fontSize: '1.5rem'}}>Consultanță</span></h3>
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Nume & Prenume *"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Adresă E-Mail*"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Număr de Telefon"
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              id="subject"
              name="title"
              placeholder="Subiect"
              required
            />
          </div>
          <div className="form-group">
            <textarea
              id="message"
              name="message"
              placeholder="O scurta descriere"
              rows="6"
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn">
            Trimite
            <FiArrowUpRight />
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact; 